import { useState } from 'react'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { AnimatePresence, motion } from 'framer-motion'

import SkillsMobile from 'components/SkillsMobile'
import SkillsWeb from 'components/SkillsWeb'
import SkillsPlanning from 'components/SkillsPlanning'
import SkillsDesign from 'components/SkillsDesign'
import SkillsServer from 'components/SkillsServer'
import SkillsWhiteBoard from 'components/SkillsWhiteBoard'
import SkillsRobot from 'components/SkillsRobot'

import BannerIcon1 from '../assets/icons/skills-bannerIcon_1.svg'
import BannerIcon2 from '../assets/icons/skills-bannerIcon_2.svg'
import BannerIcon3 from '../assets/icons/skills-bannerIcon_3.svg'
import BannerIcon4 from '../assets/icons/skills-bannerIcon_4.svg'

export default function Skills() {
  const navigate = useNavigate()
  const location = useLocation()

  const skillsList = [
    { skill: '서버', component: () => <SkillsServer />, key: 'server' },
    { skill: '웹', component: () => <SkillsWeb />, key: 'web' },
    { skill: '모바일 앱', component: () => <SkillsMobile />, key: 'mobile' },
    { skill: '기획', component: () => <SkillsPlanning />, key: 'planning' },
    { skill: '디자인', component: () => <SkillsDesign />, key: 'design' },
    { skill: '전자칠판', component: () => <SkillsWhiteBoard />, key: 'whiteBoard' },
    { skill: '로봇', component: () => <SkillsRobot />, key: 'robot' },
  ]

  const opacityVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  }
  const [selectedSkill, setSelectedSkill] = useState(0)

  const [width, setWidth] = useState(window.innerWidth)
  const isMobile = () => {
    if (width > 1024) {
      return 150
    } else {
      return 100
    }
  }

  const handleResize = () => {
    setWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const key = queryParams.get('key')

    if (key) {
      setSelectedSkill(skillsList.findIndex((item) => item.key === key))
    } else {
      setSelectedSkill(0)
    }
    // eslint-disable-next-line
  }, [location.search])

  return (
    <div className='wrapper '>
      {/* Banner */}
      <div className='flex justify-center w-full bg-sk-black'>
        <div className='flex flex-col items-center gap-40 2xs:gap-80 md:gap-120 pt-80 md:pt-[114px] pb-[44px] max-sm:pb-40 max-sm:pt-80 xl:w-[1280px] container mx-auto max-md:px-20'>
          <div className='flex items-center justify-between w-full max-lg:flex-col-reverse max-2xs:gap-20'>
            <p className='text-title2-bold lg:text-title1-bold 2xl:text-display2-bold text-sk-white max-lg:text-center'>
              시그마만의 차별화된
              <br />
              소프트웨어 종합 솔루션
            </p>
            <div className='flex items-center gap-8 sm:gap-20'>
              <img
                className='max-2xs:w-[60px] max-2xs:h-[60px] max-md:size-1/2'
                src={BannerIcon1}
                alt=''
              />
              <img
                className='max-2xs:w-[60px] max-2xs:h-[60px] max-md:size-1/2'
                src={BannerIcon2}
                alt=''
              />
              <img
                className='max-2xs:w-[60px] max-2xs:h-[60px] max-md:size-1/2'
                src={BannerIcon3}
                alt=''
              />
              <img
                className='max-2xs:w-[60px] max-2xs:h-[60px] max-md:size-1/2'
                src={BannerIcon4}
                alt=''
              />
            </div>
          </div>
          <div className='relative flex items-center md:h-[42px] max-md:flex-wrap max-md:shrink-0 max-md:gap-x-8 max-md:justify-center max-md:hidden'>
            {skillsList.map((skillItem, index) => (
              <div
                key={index}
                onClick={() => {
                  setSelectedSkill(index)
                  navigate(`/skills?key=${skillItem.key}`)
                }}
                className={`text-body1-medium sm:text-h2-medium cursor-pointer max-md:flex max-md:shrink-0 ${
                  selectedSkill === index ? 'text-sk-black' : 'text-sk-white'
                }`}
              >
                <div
                  className='relative z-10 justify-center text-center max-md:flex w-150 max-md:shrink-0'
                  style={{
                    width: `${isMobile()}px`,
                  }}
                >
                  {skillItem.skill}
                </div>
              </div>
            ))}
            <div
              className={
                'top-0 transition-all h-[42px] ease-linear duration-300 absolute flex justify-center text-body1-medium sm:text-h2-medium md:text-sk-default md:text-center md:button_white'
              }
              style={{
                width: `${isMobile()}px`,
                left: `${selectedSkill * isMobile()}px`,
              }}
            />
          </div>
          <div className='relative flex items-center md:h-[42px] max-md:flex-wrap max-md:shrink-0 max-md:gap-x-8 max-md:justify-center md:hidden gap-y-8'>
            {skillsList.map((skillItem, index) => (
              <div
                key={index}
                onClick={() => {
                  setSelectedSkill(index)
                  navigate(`/skills?key=${skillItem.key}`)
                }}
                className={`text-body1-medium sm:text-h2-medium cursor-pointer max-md:flex max-md:shrink-0 h-[42px] text-sk-white text-center`}
              >
                <div
                  className={`relative z-10 justify-center text-center max-md:flex max-2xs:w-80 w-100 sm:w-150 max-md:shrink-0 transition-all ease-linear duration-300 h-[42px] items-center
                  ${selectedSkill === index ? 'text-sk-black opacity-100 button_white' : ''}`}
                >
                  {skillItem.skill}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <AnimatePresence mode='wait'>
        <motion.div
          key={selectedSkill}
          variants={opacityVariants}
          initial='hidden'
          animate='visible'
          exit='hidden'
        >
          {skillsList[selectedSkill].component()}
        </motion.div>
      </AnimatePresence>
    </div>
  )
}
